import creditRequestController from './credit-request.controller';
import creditRequestTemplate from './credit-request.html';

export default {
  bindings: {},
  controller: creditRequestController,
  controllerAs: 'creditRequest',
  template: creditRequestTemplate
};



// WEBPACK FOOTER //
// ./src/credit-request/credit-request.component.js